import { Link } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { QueryParam } from '../queryParams/type';

type Input = DeepNullToUndefined<Link>['queryParams'];

/** Rows the editor added and left half filled are dropped. */
export const queryParamsMapper = (input: Input): QueryParam[] =>
  (input ?? []).flatMap(({ key, value }) =>
    key && value ? [{ key, value }] : [],
  );
